import axios from 'axios'
import { SERVER, PUBLIC_PATHS } from 'config'
import { getLocale } from 'i18n'

const TOKEN_KEY = 'lcost_token'

const instance = axios.create({
  baseURL: `${SERVER.url}/${SERVER.apiPath}`
})

instance.interceptors.request.use((config) => {
  let token = null
  try { token = localStorage.getItem(TOKEN_KEY) } catch { /* ignore */ }
  config.headers = config.headers || {}
  if (token) config.headers.Authorization = `Bearer ${token}`
  // The API localizes its error messages from this header.
  config.headers['Accept-Language'] = getLocale()
  return config
})

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      try {
        localStorage.removeItem(TOKEN_KEY)
        localStorage.removeItem('lcost_user')
      } catch { /* ignore */ }
      if (!PUBLIC_PATHS.includes(window.location.pathname)) {
        window.location.assign('/login')
      }
    }
    return Promise.reject(error)
  }
)

export const makeRequest = async ({ method, url, data = null, headers = {}, params = undefined, responseType = undefined }) => {
  const response = await instance.request({ method, url, data, headers, params, responseType })
  return responseType ? response : response.data
}

export const apiBase = `${SERVER.url}/${SERVER.apiPath}`
